<template>
  <empty-page fillHeight pageClass="loginPage">
    <v-layout fill-height column justify-center>
      <div>
        <v-flex xs10 offset-xs1 md6 offset-md3 lg4 offset-lg4>
          <transition name="slide-x-transition" mode="out-in">
            <router-view></router-view>
          </transition>
        </v-flex>
      </div>
    </v-layout>
    <bottom></bottom>
  </empty-page>
</template>

<script>
import Bottom from '../template/Bottom'
export default {
  components: {
    Bottom
  }
}
</script>

<style lang="scss">
.loginPage {
  background: url("/static/img/login-bg.jpg") no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
</style>
